module.exports = "pegasus_template/assets/theme3/google-icon-1.png";